export const SECOND = 1000;
export const SECONDS = SECOND;
export const MINUTE = 60 * SECOND;
export const MINUTES = MINUTE;
export const HOUR = 60 * MINUTE;
export const HOURS = HOUR;
export const DAY = 24 * HOUR;
export const DAYS = DAY;
export const WEEK = 7 * DAY;
export const WEEKS = WEEK;
export const MONTH = 30 * DAY;
export const MONTHS = MONTH;
export const YEAR = 365 * DAY;
export const YEARS = YEAR;
